import { render, staticRenderFns } from "./TabelaAvaliacao.vue?vue&type=template&id=312148cb&"
import script from "./TabelaAvaliacao.vue?vue&type=script&lang=js&"
export * from "./TabelaAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports